
export const setUpCssRules = (editor) => {
  const css = editor.Css;

  //fix hero with max-width 600px
  css.addRules(".mj-hero-fix-width { max-width: 100% !important; }");
};